// Types
import type { PopoverWrapperProps } from '@/components/base/Popover';
import { PopoverWrapper } from '@/components/base/Popover';

export function DatepickerPopover({ children, popperOptions }: PopoverWrapperProps) {
    return (
        <PopoverWrapper popperOptions={popperOptions}>
            {(propsPopoverWrapper) => children(propsPopoverWrapper)}
        </PopoverWrapper>
    );
}
